import React from 'react';
import { Motorcycle, Car, Van, Richtext } from '@adac-mp/components';

interface IAdditionalProps {
	id: number;
	categoryName: string;
	description?: React.ReactNode;
	shortText?: string;
	renderIcon: (activeState?: boolean) => JSX.Element;
}

export const getVehicleCategoriesAdditionalProps = (id: number, flowId: number, tollClasses?: any) => {
	// tollClassId same as tollCategory of Contentful
	const getCategoryDescription = (tollClassId: string, fallback: string) => {
		const categoryDescription = tollClasses?.items.find((i: any) => i.tollCategory === tollClassId)?.description;
		return categoryDescription ? <Richtext document={categoryDescription} /> : fallback;
	};

	// tollClassId same as tollCategory of Contentful
	const getCategoryName = (tollClassId: string, fallback: string) => {
		const categoryDescription = tollClasses?.items.find(
			(i: any) => i.tollCategory === tollClassId,
		)?.vehicleCategory;
		return categoryDescription || fallback;
	};

	const getCategoryShortText = (tollClassId: string, fallback: string) => {
		const categoryShortText = tollClasses?.items.find((i: any) => i.tollCategory === tollClassId)?.shortText;
		return categoryShortText || fallback;
	};
	const additionalProps: IAdditionalProps[] = [
		//id here is the same as BPCS sets it for every vehicle type
		{
			id: 3,
			categoryName: getCategoryName('1', 'Mautklasse 1'),
			description: getCategoryDescription(
				'1',
				'Einspurige Fahrzeuge (Motorräder, Motorräder mit Beiwagen und Kraftfahrzeuge mit drei Rädern, sog. Trikes).',
			),
			shortText: getCategoryShortText('1', 'z.B. Motorräder mit Beiwagen, Trikes'),
			renderIcon: (activeState?: boolean) => <Motorcycle active={activeState} />,
		},
		{
			id: 2,
			categoryName: getCategoryName('2A', 'Mautklasse 2A'),
			description: getCategoryDescription(
				'2A',
				'Zweispurige Fahrzeuge mit einer Achsenhöhe von < 1,3m (die meisten PKWs, Minivans, Geländewagen, SUVs und sog. Pick-Ups).',
			),
			shortText: getCategoryShortText('2A', 'z.B. PKW, Minivan, SUV'),
			renderIcon: (activeState?: boolean) => <Car active={activeState} />,
		},
		{
			id: 4,
			categoryName: getCategoryName('2B', 'Mautklasse 2B'),
			description: getCategoryDescription(
				'2B',
				'Zweispurige Fahrzeuge mit einem zulässigen Gesamtgewicht von ≤ 3,5t und einer Achsenhöhe von ≥ 1,3m (kombinierte und leichte Transporter).',
			),
			shortText: getCategoryShortText('2B', '> 1,3m, z.B. VW Multivan'),
			renderIcon: (activeState?: boolean) => <Van active={activeState} />,
		},
	];
	const additionalProp = additionalProps.find((prop) => prop.id === id);
	if (additionalProp) {
		if (flowId === 7 || flowId === 0) {
			return additionalProp;
		}

		const { ...rest } = additionalProp;
		delete rest.description;
		return rest;
	}
	return null;
};
